import * as React from 'react';
import { Outlet } from "react-router-dom";
import ErrorDialog from "../components/ErrorDialog.jsx";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import theme from "./theme";
import * as locales from "@mui/material/locale";
import { getChangeLogs } from '../store/features/app/appActions.js';
import { useTranslation } from 'react-i18next'


export default function Layout() {
    const dispatch = useDispatch()
    const { i18n } = useTranslation()
    const { language } = useSelector(state => state.app)
    const localValue = { "en": "enUS", "de": "deDE", "es": "esES" }
    const themeWithLocale = React.useMemo(
        () => theme("light", locales[localValue[language]]),
        [language],
    );

    React.useEffect(() => {
        void dispatch(getChangeLogs())
    }, [i18n.language])

    return (
        <ThemeProvider theme={themeWithLocale}>
            <CssBaseline />
            <Outlet />
            <ErrorDialog />
        </ThemeProvider>
    )
}